import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import TopBar from './TopBar';
import backgroundImage from '../assets/images/05.jpg';
import { AuthContext } from '../Context/AuthProvider';
import "../css/publication.css"
import Swal from 'sweetalert2';
import instance from '../Config/AxiosConfig';
import Cookies from 'js-cookie';
function NavTab() {
    const { user, isAuth } = useContext(AuthContext)
    const { id } = useParams();
    const [enseignant, setEnseignant] = useState({});
    const [universityName, setUniversityName] = useState("");
    const [departmentName, setDepartmentName] = useState("");
    const [link, setLink] = useState("");
    const [documentNumbers, setDocumentNumbers] = useState([]);
    const [connectionsNumber, setConnectionsNumber] = useState([]);
    const [interests, setInterests] = useState([])
    const [connections, setConnections] = useState([]);
    const [projects, setProjects] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [numberDocuments, setNumberDocuments] = useState([]);
    const [projectsNumber, setProjectsNumber] = useState([]);
    const [university, setUniversity] = useState('');
    const [invite, setInvite] = useState('')
    const [inviteSended, setInviteSended] = useState(false)
      useEffect(() => {
        const token = Cookies.get('token');
      
       
            instance.get(`/users/get/${id}`, token )
          
            .then(response => {
                setEnseignant(response.data);
                setUniversityName(response.data.universityName);
                setDepartmentName(response.data.departmentName);
                setLink(response.data.link);
                setConnectionsNumber(response.data.connectionsNumber);
                setDocumentNumbers(response.data.documentNumber);
                setConnections(response.data.connections);
                setInterests(response.data.interests);
                setProjects(response.data.projects);
                setDocuments(response.data.documents);
                const sortedDocuments = response.data.documents.sort((a, b) => new Date(b.publicationDate) - new Date(a.publicationDate));
                setDocuments(sortedDocuments);
                setNumberDocuments(response.data.numberDocuments);
                setProjectsNumber(response.data.projectsNumber);
                setUniversity(response.data.university);
                if (response.data.friendRequestPending) {
                    setInviteSended(true);
                } else {
                    setInviteSended(false);
                }
            })
            .catch(error => {
                console.error('Erreur lors de la récupération des données:', error);
            });
     }, []);


    console.log(inviteSended)

    const handleInvit = async (id) => {
        const token = Cookies.get('token');
        let data = new FormData();
        data.append('id', id);
        data.append('message', 'message');
        try {
            const response = await instance.post('/connectionRequests/send', data, token)
            setInvite(response)
            if (response.status === 200) {
                Swal.fire({
                    position: "top-center",
                    icon: "success",
                    title: "Connection request sent successfully.",
                    showConfirmButton: false,
                    timer: 1500,
                    imageWidth: 200,
                    imageHeight: 200,
                });
                setInviteSended(true)
            } else {
                alert("error")
            }
        }
        catch (error) {
            console.error('Erreur lors de la récupération des données:', error);
        }
    }
     
    const handleCancelInvit = async (id) => {
        const token = Cookies.get('token');
       const data = new FormData();
       data.append('id', id);
        try {
            const response = await instance.post(`/connectionRequests/cancel`,data,token )
                
    
            if (response.status === 200) {
                Swal.fire({
                    position: "top-center",
                    icon: "success",
                    title: "Invitation annulée avec succès.",
                    showConfirmButton: false,
                    timer: 1500,
                });
                setInviteSended(false); // Revenir à l'état initial
            } else {
                alert("Erreur lors de l'annulation de la demande.");
            }
        } catch (error) {
            console.error('Erreur lors de lannulation de la demande: ', error);
        }
    }
    const handleRemoveFriend = async (id) => {
        const token = Cookies.get('token');
        try {
            const response = await instance.post(`/connectionsLists/remove`, { id }, token);
            if (response.status === 200) {
                Swal.fire({
                    position: "top-center",
                    icon: "success",
                    title: "Friend removed successfully.",
                    showConfirmButton: false,
                    timer: 1500,
                });
                // Update state to reflect the friend removal
                setEnseignant(prev => ({ ...prev, isFriend: false }));
            } else {
                alert("Error removing friend.");
            }
        } catch (error) {
            console.error('Error removing friend:', error);
        }
    }
    
    return (
        <>
            <TopBar />
            <main>
                {/* Container START */}
                <div className="container">
                    <div className="row g-4">
                        {/* Main content START */}
                        <div className="col-lg-8 vstack gap-4">
                            {/* Card START */}
                            <div className="card">
                                <div className="h-200px rounded-top" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={university.logo} className="img-fluid" style={{ maxHeight: '100%' }} />
                                </div>
                                {/* Card body START */}
                                <div className="card-body py-0">
                                    <div className="d-sm-flex align-items-start text-center text-sm-start">
                                        <div>
                                            {/* Avatar */}
                                            <div className="avatar avatar-xxl mt-n5 mb-3">
                                                <img className="avatar-img rounded-circle border border-white border-3" src={enseignant.profilePicture} alt={enseignant.username} />
                                            </div>
                                        </div>
                                        <div className="ms-sm-4 mt-sm-3">
                                            {/* Info */}
                                            <h1 className="mb-0 h5">{enseignant.firstName} <i className="bi bi-patch-check-fill text-success small" /></h1>
                                            <p>{enseignant.university && enseignant.university.name}</p>
                                        </div>

                                        {/* Button */}
                                        <div className="d-flex mt-3 justify-content-center ms-sm-auto">
  
    {/* Check if state is properly initialized before rendering */}
    {typeof isAuth !== 'undefined' && typeof enseignant !== 'undefined' && (
                                                <>
                                                    {/* Show 'Add' button if authenticated and user is not the same */}
                                                    {(isAuth && enseignant.id !== user.id) && (
                                                        <>
                                                            {!inviteSended && !enseignant.isFriend && (
                                                                <button 
                                                                    className="btn btn-primary-soft me-2" 
                                                                    onClick={() => handleInvit(enseignant.id)}
                                                                >
                                                                    <i className="bi bi-person-add" style={{ fontSize: '1.5em' }} /> Add
                                                                </button>
                                                            )}
                                                            {inviteSended && (
                                                                <button  
                                                                    className="btn btn-sm btn-primary-soft me-2" 
                                                                    onClick={() => handleCancelInvit(enseignant.id)}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            )}
                                                            {enseignant.isFriend && (
                                                                <button 
                                                                    className="btn btn-sm btn-danger-soft me-2"
                                                                    onClick={() => handleRemoveFriend(enseignant.id)}
                                                                >
                                                                    Remove
                                                                </button>
                                                            )}
                                                        </>
                                                    )}

            {/* Show 'Join' button if not authenticated and enseignant is not registered */}
            {(!isAuth && !enseignant.isRegistered) && (
                <button 
                    className="btn btn-default-soft me-2" 
                    type="button" 
                    onClick={() => localStorage.setItem('userId', id)}
                >
                    <Link to="/signup">
                        <button 
                            className="btn btn-sm btn-primary-soft me-2" 
                            type="button"
                        >
                            <i className="bi bi-person-check-fill pe-1"></i> Join
                        </button>
                    </Link>
                </button>
            )}
        </>
    )}
                                         </div>

                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                {/* Tab nav line */}
                                <ul className="nav nav-tabs nav-bottom-line justify-content-center justify-content-md-start">
                                    <li className="nav-item"> <a className="nav-link active" data-bs-toggle="tab" href="#tab-1"> Publication</a> </li>
                                    <li className="nav-item"> <a className="nav-link" data-bs-toggle="tab" href="#tab-4"> Projects </a> </li>
                                    <li className="nav-item"> <a className="nav-link" data-bs-toggle="tab" href="#tab-3"> Connections</a> </li>
                                    <li className="nav-item"> <a className="nav-link" data-bs-toggle="tab" href="#tab-2"> About </a> </li>
                                </ul>
                                <div className="tab-content mb-0 pb-0">
                                    {/* tab START */}
                                    <div className="tab-pane fade " id="tab-2">
                                                                           <ul>
                                                                            <h2>Bio</h2>
                                                                            <li>
                                                                                <div >
                                                                                <p> {enseignant.aboutDescription}  </p>
                                                                                </div>
                                                                               </li>
                                                                        </ul>
                                                            </div>
                                    <div className="tab-pane fade show active" id="tab-1">
                                        <div className="card">
                                            <div className="card-header d-sm-flex align-items-center justify-content-between border-0 pb-0">
                                                <h5 className="card-title mb-sm-0">Discover Publication</h5>
                                                {/* Button modal */}
                                                <a className="btn btn-primary-soft btn-sm" href="#">    <i className="fa-solid list" /> {numberDocuments}</a>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="d-sm-flex align-items-center">
                                                        <div className="col-md-12">
                                                            <div className="tab-content p-0">
                                                                <div className="tab-pane fade active show" id="profile-post">
                                                                    {documents.map((item, index) => (
                                                                        <ul key={index} className="timeline">
                                                                            <li>
                                                                                <div className="timeline-time">

                                                                                    <span className="time fs-6">   {item.publicationDate}</span>
                                                                                </div>
                                                                                <div className="timeline-icon">
                                                                                    <a href="javascript:;">&nbsp;</a>
                                                                                </div>
                                                                                <div className="timeline-body ">
                                                                                    <div className="timeline-header">
                                                                                        <span className="username"><a href="javascript:;"> {item.titleText}</a> <small /></span>

                                                                                    </div>
                                                                                    <div className="timeline-content">
                                                                                        <p>
                                                                                            {item.link && (
                                                                                                <>
                                                                                                    <i className="bi bi-link" />
                                                                                                    {link !== null ?  
                                                                                                    <a href={item.link}>
                                                                                                    {item.link.length > 30 ? item.link.substring(0, 30) + '...' : item.link} 
                                                                                                    </a>
                                                                                                    :
                                                                                                    ""
                                                                                            }
                                                                                                    <span style={{ marginRight: '95px' }}></span> {/* Espace de 10px entre le lien et le type de document */}
                                                                                                </>
                                                                                            )}
                                                                                            <span  > <b>Type:</b>   {item.documentType} </span>
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        </ul>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="tab-3">
                                        <div className="card">
                                            {/* Card header START */}
                                            <div className="card-header d-sm-flex align-items-center justify-content-between border-0 pb-0">
                                                <h5 className="card-title mb-sm-0">Connection</h5>
                                                {/* Button modal */}
                                                <a className="btn btn-primary-soft btn-sm" href="#">    <i className="fa-solid list" /> {connectionsNumber}</a>
                                            </div>
                                                    <div className="card-body">
                                                {connections.map((item, index) => (
                                                    < div key={index} className=" d-md-flex align-items-center mb-4 mt-3" >
                                                        < div className="avatar me-3 mb-3 mb-md-0" >
                                                            <img className="avatar-img rounded-circle" src={item.profilePicture} alt={item.acronym} />
                                                        </div>
                                                        < div className="w-100" >
                                                            <div className="d-sm-flex align-items-start">
                                                                <Link to={"/profil/" + item.id}>{item.firstName}</Link>
                                                               
                                                            </div>
                                                        </div>
                                                        <div className="ms-md-auto d-flex">
                                                            <a className='text-dark' href='/messaging' > <button className="btn btn-primary-soft btn-sm mb-0"> Message </button>
                                                            </a>  </div>
                                                    </div>
                                                ))}
                                                <div className="row g-4">
                                                    <div className="col-sm-6">
                                                      </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="tab-4">
                                        <div className="card">
                                            {/* Card header START */}
                                            <div className="card-header d-sm-flex align-items-center justify-content-between border-0 pb-0">
                                                <h5 className="card-title mb-sm-0">Discover Projects</h5>
                                                {/* Button modal */}
                                                <a className="btn btn-primary-soft btn-sm" href="#">    <i className="fa-solid list" /> {projectsNumber}</a>
                                            </div>
                                            <div className="card-body">
                                           <div className="row">
                                                    <div className="d-sm-flex align-items-center">
                                                <div className="ms-sm-4 mt-2 mt-sm-0">
                                                    {projects.map((item, index) => (
                                                                <div style={{ paddingBottom: "20px" }} key={index}>
                                                                    <h5 className="mb-1"><a href="">{item.title}</a></h5>
                                                                    <p className="text-muted mb-1">{item.description}</p>
                                                                    <ul className="nav nav-stack small">
                                                                        {item.startDate && (
                                                                            <li className="nav-item"><i className="bi bi-calendar-check pe-1" /> {item.startDate}</li>
                                                                        )}
                                                                        {item.endDate && (
                                                                            <li className="nav-item">  {item.endDate}</li>
                                                                        )}

                                                                    </ul>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Right sidebar START */}
                        <div className="col-lg-4">
                            <div className="row g-4">
                                <div className="col-sm-6 col-lg-12">
                                    <div className="card">
                                        <div className="card-header border-0 pb-0">
                                            <h5 className="card-title">Resume</h5>
                                        </div>
                                        <div className="card-body position-relative pt-0">
                                            <ul className="list-unstyled mt-3 mb-0">
                                                <li className="mb-2"> <i className="bi bi-calendar-date fa-fw pe-1" /> University: <strong>{universityName}</strong>  </li>
                                                <li className="mb-2"> <i className="bi bi-heart fa-fw pe-1" /> Department: <strong> {departmentName} </strong> </li>
                                                <li className="mb-2"> <i className="bi bi-link" />   Link ResearchGate: 
                            <strong> 
        {link ? (  // Vérifie si link est non nul
            <a href={link}>
                {link.length > 20 ? link.substring(0, 20) + '...' : link}
            </a>
        ) : "No link available"}  {/* Affiche un message si le lien est nul */}
    </strong> 
</li>
                                                <li className="mb-2"  >
                                                    <i className="bi bi-star" />   Interests:
                                                    <strong> {interests.map((item, index) => item.name).join(", ")}</strong>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginBottom: '20px' }}></div>
                            {/* Card START */}
                            <div className="col-md-6 col-lg-12">
                                <div className="card">
                               
                                    <div className="card-header d-flex justify-content-between border-0">
                                        <h5 className="card-title"> Publication list</h5>
                                    </div>

                                    <div className="card-body position-relative pt-0">
                                        {/* Affichage des données récupérées depuis l'API */}
                                        {documentNumbers.map((item, index) => (
                                            <div className="d-flex" key={index}>
                                                {/* Avatar */}
                                                <div className="avatar me-3">
                                                    <img className="avatar-img rounded-circle" src={item.image} alt={item.type} style={{ width: '40px', height: '40px' }} />
                                                </div>
                                                {/* Info */}
                                                <div>
                                                    <h6 className="card-title mb-0">{item.type}</h6>
                                                    <p className="small mb-0">Number: {item.number}</p>

                                                </div>
                                           </div>

                                        ))}
                                    </div>
                                </div>
                        </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}
export default NavTab 